import type { GetApiV1ThreeLetterCodePartnerAdminsNotifications200 } from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useSearchParams } from 'react-router-dom';
import type { PushNotificationListPresentation } from '../presentations';
import { useGetPartnerAdminsNotifications } from './useGetPartnerAdminsNotifications';

type PresentationProps = React.ComponentProps<typeof PushNotificationListPresentation>;

type IUsePushNotificationList = () => {
  state: {
    /** API から取得したプッシュ通知一覧データ */
    notificationsData: GetApiV1ThreeLetterCodePartnerAdminsNotifications200;
    /** 現在のページ番号（1始まり） */
    currentPage: number;
    /** 総ページ数 */
    totalPage: number;
    /** 総件数 */
    totalCount: number;
  };
  actions: {
    /** ページ変更時のハンドラ */
    handlePageChange: PresentationProps['pagerProps']['onPageChange'];
  };
};

/**
 * プッシュ通知一覧の状態管理とアクションを提供するコンポーネントフック
 *
 * - URL クエリパラメータ（page）でページング状態を管理する
 */
export const usePushNotificationList: IUsePushNotificationList = () => {
  const [filterParams, setFilterParams] = useSearchParams();
  const threeLetterCode = getThreeLetterCode() ?? '';

  const {
    data: notificationsData,
    totalPage,
    totalCount,
  } = useGetPartnerAdminsNotifications({
    threeLetterCode,
    page: filterParams.get('page') || undefined,
  });

  const currentPage = Number(filterParams.get('page')) || 1;

  /**
   * ページ変更時のハンドラ
   *
   * @param page 遷移先のページ番号（1始まり）
   */
  const handlePageChange: PresentationProps['pagerProps']['onPageChange'] = page => {
    const newParams = new URLSearchParams(filterParams);
    newParams.set('page', String(page));
    setFilterParams(newParams);
  };

  return {
    state: { notificationsData, currentPage, totalPage, totalCount },
    actions: { handlePageChange },
  };
};
